<template>
  <q-card flat :style="!$q.screen.lt.md && isDialog?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="row items-center q-pb-none" v-if="isDialog">
      <div>
        {{ selectedCustomer.Cs_Name }}
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>

    <q-card-section class="no-padding">
      <q-input type="search" label="جستجو..." v-model="filter" filled :dense="$q.screen.lt.md">
        <template v-slot:append>
          <q-btn round flat icon="filter_alt" @click="showFilterDialog">
            <q-tooltip>
              فیلتر نمودن اطلاعات
            </q-tooltip>
          </q-btn>
        </template>
      </q-input>
      <q-table
          style="height: 800px"
          :data="itemsOptions"
          row-key="Sale_Num"
          flat
          :filter="filter"
          wrap-cells
          virtual-scroll
          :rows-per-page-options="[0]"
          :pagination.sync="pagination">
        <template v-slot:header>
          <tr class="text-center text-subtitle1">
            <td v-if="showOnlyExitDocument===false">#</td>
            <td>فاکتور</td>
            <td>سفارش</td>
            <td>حواله</td>
            <td>تاریخ فاکتور</td>
            <td>تعداد</td>
            <td v-if="showOnlyExitDocument===false">مبلغ</td>
            <td>طرف معامله</td>
            <td>استان</td>
            <td>شهر</td>
          </tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class" v-if="props.row.Sale_State === sale_state">
            <td v-if="showOnlyExitDocument===false" style="width: 285px">
              <q-card class="no-padding" flat>
                <q-card-section class="no-padding" horizontal>
                  <q-btn v-if="props.row.Sale_Kind===1 && props.row.Sale_State===0" flat padding="none" size="lg" round
                         class="q-mt-xs"
                         color="positive" icon="check"
                         @click="setSaleState(props.row.Sale_Num)">
                    <q-tooltip>
                      تایید فاکتور
                    </q-tooltip>
                  </q-btn>
                  <q-btn round flat icon="timeline" color="indigo" @click="showOrderTimeLine(props.row)">
                    <q-tooltip>
                      رهگیری سفارش
                    </q-tooltip>
                  </q-btn>
                  <q-btn flat round
                         color="indigo"
                         icon="print"
                         v-if="props.row.Sale_Kind===1"
                         @click="printfactor(props.row)"/>
                  <q-btn
                      v-if="props.row.Sale_Kind===1 && props.row.Sale_PayReceive !== props.row.Sale_Pay && $store.state.roles.some(v=>['admin','can_save_receive_pay'].includes(v))"
                      flat
                      round
                      color="green"
                      icon="attach_money">
                    <q-tooltip>
                      ثبت رسید پرداخت
                    </q-tooltip>
                    <q-popup-edit
                        persistent
                        buttons
                        v-model="props.row.Sale_PayReceive"
                        @save="(val) => setMoneyBack(val, props.row)"
                    >
                      <q-field
                          v-model="props.row.Sale_PayReceive"
                          mask="currency"
                          label="مبلغ دریافتی"
                          label-color="indigo"
                          autofocus
                          filled
                          dir="ltr"
                          lazy-rules
                          :rules="[
                              val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ دریافتی را وارد نمایید',
                              val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ دریافتی عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                        <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                          <input :id="id" class="q-field__native text-right" :value="value"
                                 @change="e => emitValue(e.target.value)"
                                 v-money="moneyFormatForDirective"
                                 v-show="floatingLabel">
                        </template>
                      </q-field>
                      <q-input dir="ltr" filled v-model="props.row.Sale_PayDate" mask="date" :rules="['date']"
                               label="تاریخ پرداخت" clearable>
                        <template v-slot:append>
                          <q-icon name="event" class="cursor-pointer">
                            <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                              <q-date v-model="props.row.Sale_PayDate" calendar="persian">
                                <div class="row items-center justify-center">
                                  <q-btn v-close-popup label="تایید" color="primary" flat/>
                                  <q-btn v-close-popup @click="props.row.Sale_PayDate = ToJalaliDate(new Date())"
                                         label="امروز" color="primary"
                                         flat/>
                                </div>
                              </q-date>
                            </q-popup-proxy>
                          </q-icon>
                        </template>
                      </q-input>

                    </q-popup-edit>
                  </q-btn>
                  <q-btn
                      flat
                      round
                      color="deep-orange"
                      icon="assignment_return"
                      @click="showReturnOrderDialog(props.row)"
                      v-if="props.row.Sale_Kind===1 && props.row.LastTraceinfo==='برگشت سفارش' && $store.state.roles.some(v=>['admin','can_return_factor'].includes(v)) && !props.row.BaseSale_Num">
                    <q-tooltip>
                      صدور سند برگشت
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="$store.state.roles.some(v=>['admin','can_delete_factor'].includes(v))"
                      flat round class="q-mt-xs"
                      color="negative" icon="delete"
                      :disable="props.row.LastTraceinfo!=='حذف' || props.row.LastTraceinfo==='سند حسابداری زده شد'"
                      @click="deleteFactor(props.row)">
                    <q-tooltip>
                      حذف فاکتور
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                      v-if="props.row.Sale_Kind===1 && props.row.CustomerRequestID && $store.state.roles.some(v=>['admin','can_send_factor'].includes(v))"
                      round flat icon="mail" color="indigo"
                      @click="sendFactorLink(props.row.CustomerRequestID, props.row.Cs_Mobile,'فاکتور',props.row.Cs_Name, props.row.Order_Num)">
                    <q-tooltip>
                      ارسال برای طرف معامله
                    </q-tooltip>
                  </q-btn>
                  <q-btn icon="attach_file" color="blue-grey" flat round
                         @click="loadUploadDialog(props.row)"
                         v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                               && !props.row.HasAttachment">
                    <q-tooltip>
                      ضمیمه نمودن فاکتور فروش
                    </q-tooltip>
                  </q-btn>
                  <q-btn icon="attach_file" color="blue-grey" flat round
                         @click="downloadAttachment(props.row)"
                         v-if="$store.state.roles.some(v=>['admin','can_attach_sale_fac_document','user_sell'].includes(v))
                                               && props.row.HasAttachment">
                    <q-tooltip>
                      دانلود ضمیمه
                    </q-tooltip>
                  </q-btn>
                </q-card-section>
              </q-card>
            </td>
            <td>
              <q-badge color="red" text-color="white" label="سند برگشتی" v-if="props.row.Sale_Kind===-1"/>
              <q-space/>
              <q-chip :size="$q.screen.lt.md?'md':'md'" :clickable="showOnlyExitDocument===false" square color="indigo"
                      text-color="white"
                      icon="qr_code" :label="props.row.Sale_Num" @click="showDetails(props.row)"/>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="indigo" text-color="white"
                      icon="qr_code"> ({{ props.row.Order_Num }})
              </q-chip>
            </td>
            <td>
              <q-chip clickable @click="showExitDocumentDetails(props.row)" :size="$q.screen.lt.md?'md':'md'" square
                      color="indigo" text-color="white"
                      icon="qr_code"> ({{ props.row.Hava_Num }})
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="red" icon="event" outline>
                ({{ props.row.Sale_Date }})
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="purple" icon="functions"
                      text-color="white">
                {{ props.row.Sale_Count }} عدد
              </q-chip>
            </td>
            <td v-if="showOnlyExitDocument===false">
              <q-chip :size="$q.screen.lt.md?'md':'md'" square color="green-14" icon="attach_money"
                      text-color="white">
                {{ props.row.Sale_Pay | toCurrency }} ریال
              </q-chip>
            </td>
            <td>
              <q-chip clickable :size="$q.screen.lt.md?'md':'md'" square icon="person"
                      @click="showCustomerInfo(props.row)">
                {{ props.row.Cs_Name }}
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                {{ props.row.City_Name }}
              </q-chip>
            </td>
            <td>
              <q-chip :size="$q.screen.lt.md?'md':'md'" square icon="business">
                {{ props.row.State_Name }}
              </q-chip>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <factor-details :sale-state="selectedFactor.Sale_State" :sale-num="selectedSaleNum"
                      :sale-kind="selectedFactor.Sale_Kind" :factor-items="factorItems"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :sale-num="parseInt(selectedSaleNum)" :sale-date="selectedSaleDate"
                     @refresh-data="changeRow"
                     :remain-ordered="false"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="orderTraceFilterDialog">
      <OrderTraceFilterEditor :input-companies.sync="filterInfo.selectedCompanies"
                              :input-states.sync="filterInfo.selectedStates"
                              :input-cities.sync="filterInfo.selectedCities"
                              @apply-filter="applyFilter"/>
    </q-dialog>
    <q-dialog maximized v-model="returnOrderDialog">
      <IssueReturnOrder :cs-i-d="selectedFactor.Cs_ID" :sale-num="selectedFactor.Sale_Num"
                        :hava-num="selectedFactor.Hava_Num" @refresh-data="closeReturnOrderDialog"/>
    </q-dialog>
    <q-dialog v-model="exitDocumentDialog">
      <HavaDetails :sale-num="selectedFactor.Sale_Num"
                   :hava_num="selectedFactor.Hava_Num"
                   :store_id="[1,2,3,4,5,6]"
                   :sale-kind="selectedFactor.Sale_Kind"/>
    </q-dialog>
    <q-dialog v-model="uploadDocumentDialog">
      <SaleFacLisAttachment v-if="selectedOrder && selectedOrder.Sale_Num"
                            :filename="selectedOrder.Sale_Num.toString()"
                            @uploaded_finish="uploadedFinish"
                            :file-kind="selectedOrder.Sale_Kind"/>
    </q-dialog>
    <q-dialog v-model="factorPrintDialog">
      <FactorPrintDialog :factor-info="selectedFactor" title="چاپ فاکتور"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";
import FactorDetails from "@/components/Factor/FactorDetails";
import CustomerInfo from "@/components/customers/CustomerInfo";
import OrderTraceFilterEditor from "@/components/OrderTrace/OrderTraceFilterEditor";
import EventBus from "@/event-bus";
import IssueReturnOrder from "@/components/Remittance/IssueReturnOrder";
import HavaDetails from "@/components/customers/HavaDetails";
import SaleFacLisAttachment from "@/components/orders/SaleFacListAttachment.vue";
import FactorPrintDialog from "@/components/PrintDialogs/FactorPrintDialog.vue";

export default {
  name: "FactorHistoryDesktop",
  components: {
    FactorPrintDialog,
    SaleFacLisAttachment,
    HavaDetails, IssueReturnOrder, OrderTraceFilterEditor, CustomerInfo, FactorDetails, OrderTimeLine},
  props: {
    orderHistoryList: {
      type: Array,
      default:()=>[]
    },
    defaultSaleState: {},
    isDialog: {
      type: Boolean
    },
    showOnlyExitDocument: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      factorPrintDialog:false,
      exitDocumentDialog: false,
      returnOrderDialog: false,
      orderTraceFilterDialog: false,
      selectedSaleDate: '',
      filterInfo: {
        selectedCompanies: null,
        selectedStates: null,
        selectedCities: null,
        selectedGoodsGroup: null,
        selectedGoods: null
      },
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      moneyBack: 0,
      items: [],
      itemsOptions: [],
      filter: '',
      selectedCustomer: '',
      selectedFactor: '',
      customerInfoDialog: false,
      factorItems: [],
      showOrderDetailsDialog: false,
      showTimeLineDialog: false,
      selectedSaleNum: '',
      sale_state: false,
      pagination: {
        rowsPerPage: 0
      },
      selectedOrder: undefined,
      uploadDocumentDialog: false
    }
  },
  methods: {
    ...mapActions({
      setSaleState: 'Orders/setSaleState',
      setFinalOrder: 'Orders/setSaleFinalState',
      getFactorItems: 'Orders/getFactorItems',
      getCustomerInfo: 'Customers/get_customer_info',
      deleteFactorBySaleNum: 'Orders/deleteFactor',
      MoneyBackAction: 'Orders/receiveFactorPay',
      SendSMS: 'send_sms_by_user',
      downloadFile: 'Orders/downloadFile',
    }),
    loadUploadDialog(rowInfo) {
      this.selectedOrder = rowInfo
      this.uploadDocumentDialog = true
    },
    uploadedFinish(args) {
      this.$emit('attachment-uploaded', args)
      this.selectedOrder.HasAttachment = true
      this.uploadDocumentDialog = false
    },
    downloadAttachment(args) {
      this.downloadFile(
          {
            filePath: `SaleOrders/${args.Sale_Num}_${args.Sale_Kind}.pdf`,
            fileExtension: 'pdf',
            mimeType: 'application/pdf'
          }).then(async (res) => {
        await this.openURL(res.data.publicLink)
      })
    },
    closeReturnOrderDialog() {
      this.returnOrderDialog = false;
    },
    changeRow(arg) {
      let founded = this.itemsOptions.filter(item => item.Order_Num === arg.data.Sale_Num)
      if (founded && founded.length > 0) {
        founded[0].LastTraceinfo = arg.data.title
        founded[0].ReasonDescription = arg.data.ReasonDescription
      }

      founded = this.items.filter(item => item.Order_Num === arg.data.Sale_Num)
      if (founded && founded.length > 0) {
        founded[0].LastTraceinfo = arg.data.title
        founded[0].ReasonDescription = arg.data.ReasonDescription
      }
    },
    async sendFactorLink(requestid, phoneNo, ty, customerName, sale_num) {
      this.$q.dialog({
        title: 'نحوه ارسال',
        message: 'نحوه ارسال فاکتور را مشخص کنید؟',
        persistent: false,
        ok: {
          label: 'لینک فاکتور/پیش فاکتور'
        },
        cancel: {
          label: 'لینک پرداخت',
          color: 'green',
          flat: true
        },
      }).onOk(() => {
        this.SendSMS({
          phoneNo: phoneNo,
          Sale_Num: sale_num,
          Message: `نوران، سلام \n مشتری عزیز ${`(${customerName})`} شما می توانید از طریق لینک زیر اطلاعات ${ty} خود را مشاهده نمایید. لازم به ذکر است مدت اعتبار دسترسی به  ${ty} 1 روز می باشد \nhttps://ecapp-report.norl.ir/CustomerViewer?requestid=${requestid}`
        }).then(() => {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            message: 'پیامک ارسال گردید',
            position: 'top'
          })
        }).catch(() => {
          this.$q.notify({
            type: 'negative',
            color: 'negative',
            message: 'پیامک ارسال نگردید',
            position: 'top'
          })
        })
      }).onCancel(() => {
      }).onDismiss(() => {
      })
    },
    setMoneyBack(val, row) {
      if (!val.replaceAll(',', '') || val.replaceAll(',', '') === '0' || !row.Sale_PayDate || row.Sale_PayDate.trim() === '') {
        this.$q.notify({
          message: `کلیه اطلاعات خواسته شده را وارد کنید`,
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.MoneyBackAction({
          saleNum: row.Sale_Num,
          Sale_PayDay: val.replaceAll(',', ''),
          Sale_PayDate: row.Sale_PayDate
        }).then(() => {
          this.$q.notify({
            message: `رسید پرداخت فاکتور ${row.Sale_Num} ثبت گردید`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          row.Sale_PayReceive = val
        })
      }
    },
    applyFilter(arg) {
      this.filterInfo.selectedCompanies = arg.selectedCompanies === null || arg.selectedCompanies === undefined ? [] : arg.selectedCompanies
      this.filterInfo.selectedStates = arg.selectedStates === null || arg.selectedStates === undefined ? [] : arg.selectedStates
      this.filterInfo.selectedCities = arg.selectedCities == null || false || false ? [] : arg.selectedCities
      this.filterInfo.selectedGoodsGroup = arg.selectedGoodsGroup == null || false ? [] : arg.selectedGoodsGroup
      this.filterInfo.selectedGoods = arg.selectedGoods == null || false ? [] : arg.selectedGoods

      let comIDs = this.filterInfo.selectedCompanies.map(record => record.CompID)
      let stateIDs = this.filterInfo.selectedStates.map(record => record.State_ID)
      let cityIDs = this.filterInfo.selectedCities.map(record => record.City_ID)
      let goodsGroupIDs = this.filterInfo.selectedGoodsGroup.map(record => record.Group_ID)
      let goodsIDs = this.filterInfo.selectedGoods.map(record => record.Goods_ID)

      this.itemsOptions =
          this.items.filter(item =>
              (comIDs.includes(item.CompID) || comIDs.length === 0) &&
              (stateIDs.includes(item.CsState_ID) || stateIDs.length === 0) &&
              (cityIDs.includes(item.CsCity_ID) || cityIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_Group))], goodsGroupIDs).length > 0 || goodsGroupIDs.length === 0) &&
              (item.GoodsGroup && this.lodash.intersection([...new Set(JSON.parse(item.GoodsGroup).map(c => c.Goods_ID))], goodsIDs).length > 0 || goodsIDs.length === 0)
          )
    },
    showFilterDialog() {
      this.orderTraceFilterDialog = true
    },
    async printfactor(item) {
      this.selectedFactor = item
      this.factorPrintDialog = true
    },
    deleteFactor(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از حذف فاکتور اطمینان دارید؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.deleteFactorBySaleNum(
            {
              saleNum: row.Sale_Num,
              saleKind: row.Sale_Kind
            }
        ).then(() => {
          this.items = this.items.filter(item => item.Sale_Num !== row.Sale_Num)
          this.itemsOptions = this.itemsOptions.filter(item => item.Sale_Num !== row.Sale_Num)
        })
      })
    },
    showDetails(row) {
      this.getFactorItems({
        sale_num: row.Sale_Num,
        sale_kind: row.Sale_Kind
      }).then((res) => {
        this.factorItems = res;
        this.selectedSaleNum = row.Sale_Num;
        this.selectedFactor = row
        this.showOrderDetailsDialog = true;
      })
    },
    showExitDocumentDetails(row) {
      this.selectedFactor = row
      this.exitDocumentDialog = true
    },
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0];
        this.customerInfoDialog = true;
      })
    },
    SetFinalSaleState(row) {
      this.setFinalOrder(row.Sale_Num).then((res) => {
        if (res.data.msg === 'success') {
          this.$q.notify({
            message: `فاکتور ${row.Sale_Num}تایید گردید `,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          row.Sale_StateModir = 1
        }
      })
    },
    setSaleState(sale_num) {
      this.$q.dialog({
        title: 'تاییدیه نقد بودن خرید',
        message: 'آیا خرید طرف معامله نقدی می باشد؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: true
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `فاکتور ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      }).onCancel(() => {
        this.setSaleState({
          sale_num: sale_num,
          cash: false
        }).then((res) => {
          if (res.data.msg === "success") {
            this.$q.notify({
              message: `فاکتور ${sale_num}نهایی گردید `,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        }).catch(() => {
          this.$q.notify({
            message: 'طرف معامله اعتبار کافی ندارد',
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        });
      }).onDismiss(() => {

      })
    },
    showOrderTimeLine(row) {
      this.selectedSaleNum = row.Order_Num;
      this.selectedSaleDate = row.Sale_Date
      this.showTimeLineDialog = true;
    },
    showReturnOrderDialog(row) {
      if (row.LastTraceinfo !== 'برگشت سفارش') {
        this.$q.notify({
          message: 'به دلیل عدم ثبت برچسب برگشت سفارش امکان ثبت سند برگشت میسر نمی باشد',
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.selectedFactor = row
        this.returnOrderDialog = true;
      }
    }
  },
  created() {
    if (this.defaultSaleState === undefined) {
      this.sale_state = 1

    } else {
      this.sale_state = this.defaultSaleState
    }
  },
  mounted() {
    EventBus.$on('invoke-factor-list', payload => {
      this.items = payload;
      this.itemsOptions = this.items
    });
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
